const {unauthorizedRedirect} = require('../auth');
const cookie = require('react-cookie');
const request = require('superagent-use')(require('superagent'));
const Promise = require('es6-promise').Promise;
require('superagent-auth-bearer')(request);

request.use(unauthorizedRedirect);

const CamerasApi = {
  get: url => {
    let token = cookie.load('JWT');
    return new Promise((resolve, reject) => {
      request
        .get(url)
        .authBearer(token)
        .timeout({response: 10000, deadline: 60000})
        .end((err, res) => {
          if (err || !res.ok)
            reject({ error: err, res: res });
          else
            resolve(res);
        });
    });
  },
  delete: url => {
    let token = cookie.load('JWT');
    return new Promise((resolve, reject) => {
      request
        .del(url)
        .authBearer(token)
        .end((err, res) => {
          if (err || !res.ok)
            reject({ error: err, res: res });
          else
            resolve(res.header);
        });
    });
  },
  exportConfig: url => {
    let token = cookie.load('JWT');
    return new Promise((resolve, reject) => {
      request
        .get(url)
        .authBearer(token)
        .end((err, res) => {
          if (err || !res.ok)
            reject({ error: err, res: res });
          else
            resolve(res);
        });
    });
  },
  importConfig: (url, config, progress) => {
    let token = cookie.load('JWT');
    return new Promise((resolve, reject) => {
      request
        .put(url)
        .authBearer(token)
        .set('Content-Type', 'application/json')
        .send(config)
        .on('progress', progress)
        .end((err, res) => {
          if (err || !res.ok) {
            let errorResponse = err.response
              ? JSON.parse(err.response.text)
              : { error: 'There was an error uploading the configuration' };
            reject({ errorMessage: errorResponse, res: res });
          }
          else
            resolve(res.body);
        });
    });
  }
}

export default CamerasApi;
